import { createStore } from 'vuex';
import { BUSINESS_HOUR_STATUS } from '@/libs/constants.js';

export default createStore({
  state: {
    user: {
      authInfo: '',
      username: '',
      companyID: '',
      userID: '',
      clientName: '',
      phoneNumber: '',
      firebaseConfig: null,
    },
    screen: {
      currentScreenName: '',
      status: '',
    },
    logedIn: false,
    onlineStatus: false,
    businessHour: BUSINESS_HOUR_STATUS.OUT_OF_SERVICE,
    latestRequestTime: null,
  },
  mutations: {
    loginUser(state, user) {
      user.username = user.username ? user.username.replace('_', ' ') : '';
      state.user = user;
    },
    loginStatus(state, status) {
      state.logedIn = status;
    },
    onlineStatus(state, status) {
      state.onlineStatus = status;
    },
    businessHour(state, status) {
      state.businessHour = status;
    },
    latestRequestTime(state, time) {
      state.latestRequestTime = time;
    },
    screen(state, status) {
      state.screen = status;
    },
  },
  actions: {
    updateLoginInfo({ commit }, user) {
      commit('loginUser', user);
    },
    updateLoggedInStatus({ commit }, status) {
      commit('loginStatus', status);
    },
    updateOnlineStatus({ commit }, status) {
      commit('onlineStatus', status);
    },
    updateBusinessHour({ commit }, status) {
      commit('businessHour', status);
    },
    updateLatestRequestTime({ commit }) {
      commit('latestRequestTime', new Date().getTime());
    },
    updateScreen({ commit }, status) {
      commit('screen', status);
    },
  },
  modules: {},
});
